import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Table,
	Statistic,
	Row,
	Col,
	Button,
	notification,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSearch, CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { getAggregateCogsCost } from "../utils/CogCost";

const { Text } = Typography;

const SalesBySellerSummary = () => {
	const [loading, setLoading] = useState(false);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [list, setList] = useState([]);
	const [listCSV, setListCSV] = useState([]);
	const [sellerOptions, setSellerOptions] = useState([]);
	const [seller, setSeller] = useState("All");
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Seller",
			dataIndex: "seller",
			key: "seller",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Mix Design",
			dataIndex: "psi",
			key: "psi",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total CY",
			dataIndex: "totalYards",
			key: "totalYards",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Total $",
			dataIndex: "totalUnitPrice",
			key: "totalUnitPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Average $",
			dataIndex: "totalAverage",
			key: "totalAverage",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "CY",
			children: [
				{
					title: "Mission",
					dataIndex: "missionCY",
					key: "missionCY",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
				{
					title: "San Benito",
					dataIndex: "sanbenitoCY",
					key: "sanbenitoCY",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
				{
					title: "Brownsville",
					dataIndex: "brownsvilleCY",
					key: "brownsvilleCY",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
			],
		},
		{
			title: "Commission by plant",
			children: [
				{
					title: "Mission",
					dataIndex: "missionCommission",
					key: "missionCommission",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				{
					title: "San Benito",
					dataIndex: "sanbenitoCommission",
					key: "sanbenitoCommission",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				{
					title: "Brownsville",
					dataIndex: "brownsvilleCommission",
					key: "brownsvilleCommission",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			],
		},
		{
			title: "Seller Pay out",
			children: [
				{
					title: "Mission",
					dataIndex: "missionPayout",
					key: "missionPayout",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				{
					title: "San Benito",
					dataIndex: "sanbenitoPayout",
					key: "sanbenitoPayout",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				{
					title: "Brownsville",
					dataIndex: "brownsvillePayout",
					key: "brownsvillePayout",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			],
		},
		{
			title: "Clients",
			dataIndex: "client",
			key: "client",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "COGS",
			children: [
				{
					title: "Mission",
					dataIndex: "missionCogs",
					key: "missionCogs",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={4}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				{
					title: "San Benito",
					dataIndex: "sanbenitoCogs",
					key: "sanbenitoCogs",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={4}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				{
					title: "Brownsville",
					dataIndex: "brownsvilleCogs",
					key: "brownsvilleCogs",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={4}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			],
		},
		{
			title: "SALES",
			children: [
				{
					title: "Mission",
					dataIndex: "missionSales",
					key: "missionSales",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				{
					title: "San Benito",
					dataIndex: "sanbenitoSales",
					key: "sanbenitoSales",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				{
					title: "Brownsville",
					dataIndex: "brownsvilleSales",
					key: "brownsvilleSales",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			],
		},
		{
			title: "GROSS",
			children: [
				{
					title: "Mission",
					dataIndex: "missionGross",
					key: "missionGross",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				{
					title: "San Benito",
					dataIndex: "sanbenitoGross",
					key: "sanbenitoGross",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				{
					title: "Brownsville",
					dataIndex: "brownsvilleGross",
					key: "brownsvilleGross",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			],
		},
		// {
		// 	title: "AVERAGE",
		// 	children: [
		// 		{
		// 			title: "Cogs",
		// 			dataIndex: "cogsAverage",
		// 			key: "cogsAverage",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "Sales",
		// 			dataIndex: "salesAverage",
		// 			key: "salesAverage",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 		{
		// 			title: "Gross",
		// 			dataIndex: "grossAverage",
		// 			key: "grossAverage",
		// 			render: (value) => {
		// 				return (
		// 					<Statistic
		// 						title=""
		// 						value={value}
		// 						precision={2}
		// 						valueStyle={{ fontSize: 14 }}
		// 						prefix={"$"}
		// 					/>
		// 				);
		// 			},
		// 		},
		// 	],
		// },
		// {
		// 	title: "Utility",
		// 	dataIndex: "utility",
		// 	key: "utility",
		// 	render: (value) => {
		// 		return (
		// 			<Statistic
		// 				title=""
		// 				value={value}
		// 				precision={2}
		// 				valueStyle={{ fontSize: 14 }}
		// 				prefix={"$"}
		// 			/>
		// 		);
		// 	},
		// },
	];

	const summaryParent = (pageData) => {
		let totalYardsTotal = 0;
		let totalUnitPriceTotal = 0;
		let missionCYTotal = 0;
		let sanbenitoCYTotal = 0;
		let brownsvilleCYTotal = 0;
		let missionCommissionTotal = 0;
		let sanbenitoCommissionTotal = 0;
		let brownsvilleCommissionTotal = 0;
		let missionPayoutTotal = 0;
		let sanbenitoPayoutTotal = 0;
		let brownsvillePayoutTotal = 0;
		let missionCogsTotal = 0;
		let sanbenitoCogsTotal = 0;
		let brownsvilleCogsTotal = 0;
		let missionSalesTotal = 0;
		let sanbenitoSalesTotal = 0;
		let brownsvilleSalesTotal = 0;
		let missionGrossTotal = 0;
		let sanbenitoGrossTotal = 0;
		let brownsvilleGrossTotal = 0;

		pageData.forEach(
			({
				totalYards,
				totalUnitPrice,
				missionCY,
				sanbenitoCY,
				brownsvilleCY,
				missionCogs,
				sanbenitoCogs,
				brownsvilleCogs,
				missionSales,
				sanbenitoSales,
				brownsvilleSales,
				missionGross,
				sanbenitoGross,
				brownsvilleGross,
				missionCommission,
				sanbenitoCommission,
				brownsvilleCommission,
				missionPayout,
				sanbenitoPayout,
				brownsvillePayout,
			}) => {
				totalYardsTotal += totalYards;
				totalUnitPriceTotal += totalUnitPrice;
				missionCYTotal += missionCY || 0;
				sanbenitoCYTotal += sanbenitoCY || 0;
				brownsvilleCYTotal += brownsvilleCY || 0;
				missionCogsTotal += missionCogs || 0;
				sanbenitoCogsTotal += sanbenitoCogs || 0;
				brownsvilleCogsTotal += brownsvilleCogs || 0;
				missionSalesTotal += missionSales || 0;
				sanbenitoSalesTotal += sanbenitoSales || 0;
				brownsvilleSalesTotal += brownsvilleSales || 0;
				missionGrossTotal += missionGross || 0;
				sanbenitoGrossTotal += sanbenitoGross || 0;
				brownsvilleGrossTotal += brownsvilleGross || 0;
				missionCommissionTotal += missionCommission || 0;
				sanbenitoCommissionTotal += sanbenitoCommission || 0;
				brownsvilleCommissionTotal += brownsvilleCommission || 0;
				missionPayoutTotal += missionPayout || 0;
				sanbenitoPayoutTotal += sanbenitoPayout || 0;
				brownsvillePayoutTotal += brownsvillePayout || 0;
			}
		);

		return (
			<>
				<Table.Summary.Row>
					<Table.Summary.Cell colSpan={2} />
					<Table.Summary.Cell>
						<Text style={{ fontSize: 14 }} strong>
							{"Total"}
						</Text>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalYardsTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalUnitPriceTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell colSpan={1} />
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={missionCYTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={sanbenitoCYTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={brownsvilleCYTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={missionCommissionTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={sanbenitoCommissionTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={brownsvilleCommissionTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={missionPayoutTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={sanbenitoPayoutTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={brownsvillePayoutTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell colSpan={1} />
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={missionCogsTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={sanbenitoCogsTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={brownsvilleCogsTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={missionSalesTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={sanbenitoSalesTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={brownsvilleSalesTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={missionGrossTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={sanbenitoGrossTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={brownsvilleGrossTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
				</Table.Summary.Row>
			</>
		);
	};

	const expandedRowRender = (row) => {
		const columns = [
			{
				title: "Seller",
				dataIndex: "seller",
				key: "seller",
				render: (value) => {
					return <Text>{value}</Text>;
				},
			},
			{
				title: "Mix Design",
				dataIndex: "psi",
				key: "psi",
				render: (value) => {
					return <Text>{value}</Text>;
				},
			},
			{
				title: "Total CY",
				dataIndex: "totalYards",
				key: "totalYards",
				render: (value) => {
					return (
						<Statistic
							title=""
							value={value}
							precision={2}
							valueStyle={{ fontSize: 14 }}
						/>
					);
				},
			},
			{
				title: "Total $",
				dataIndex: "totalUnitPrice",
				key: "totalUnitPrice",
				render: (value) => {
					return (
						<Statistic
							title=""
							value={value}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					);
				},
			},
			{
				title: "Average $",
				dataIndex: "totalAverage",
				key: "totalAverage",
				render: (value) => {
					return (
						<Statistic
							title=""
							value={value}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					);
				},
			},
			{
				title: "CY",
				children: [
					{
						title: "Mission",
						dataIndex: "missionCY",
						key: "missionCY",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
								/>
							);
						},
					},
					{
						title: "San Benito",
						dataIndex: "sanbenitoCY",
						key: "sanbenitoCY",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
								/>
							);
						},
					},
					{
						title: "Brownsville",
						dataIndex: "brownsvilleCY",
						key: "brownsvilleCY",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
								/>
							);
						},
					},
				],
			},
			{
				title: "Commission by plant",
				children: [
					{
						title: "Mission",
						dataIndex: "missionCommission",
						key: "missionCommission",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
					{
						title: "San Benito",
						dataIndex: "sanbenitoCommission",
						key: "sanbenitoCommission",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
					{
						title: "Brownsville",
						dataIndex: "brownsvilleCommission",
						key: "brownsvilleCommission",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
				],
			},
			{
				title: "Seller Pay out",
				children: [
					{
						title: "Mission",
						dataIndex: "missionPayout",
						key: "missionPayout",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
					{
						title: "San Benito",
						dataIndex: "sanbenitoPayout",
						key: "sanbenitoPayout",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
					{
						title: "Brownsville",
						dataIndex: "brownsvillePayout",
						key: "brownsvillePayout",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
				],
			},
			{
				title: "Clients",
				dataIndex: "client",
				key: "client",
				render: (value) => {
					return <Text>{value}</Text>;
				},
			},
			{
				title: "COGS",
				children: [
					{
						title: "Mission",
						dataIndex: "missionCogs",
						key: "missionCogs",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={4}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
					{
						title: "San Benito",
						dataIndex: "sanbenitoCogs",
						key: "sanbenitoCogs",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={4}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
					{
						title: "Brownsville",
						dataIndex: "brownsvilleCogs",
						key: "brownsvilleCogs",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={4}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
				],
			},
			{
				title: "SALES",
				children: [
					{
						title: "Mission",
						dataIndex: "missionSales",
						key: "missionSales",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
					{
						title: "San Benito",
						dataIndex: "sanbenitoSales",
						key: "sanbenitoSales",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
					{
						title: "Brownsville",
						dataIndex: "brownsvilleSales",
						key: "brownsvilleSales",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
				],
			},
			{
				title: "GROSS",
				children: [
					{
						title: "Mission",
						dataIndex: "missionGross",
						key: "missionGross",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
					{
						title: "San Benito",
						dataIndex: "sanbenitoGross",
						key: "sanbenitoGross",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
					{
						title: "Brownsville",
						dataIndex: "brownsvilleGross",
						key: "brownsvilleGross",
						render: (value) => {
							return (
								<Statistic
									title=""
									value={value}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							);
						},
					},
				],
			},
			// {
			// 	title: "AVERAGE",
			// 	children: [
			// 		{
			// 			title: "Cogs",
			// 			dataIndex: "cogsAverage",
			// 			key: "cogsAverage",
			// 			render: (value) => {
			// 				return (
			// 					<Statistic
			// 						title=""
			// 						value={value}
			// 						precision={2}
			// 						valueStyle={{ fontSize: 14 }}
			// 						prefix={"$"}
			// 					/>
			// 				);
			// 			},
			// 		},
			// 		{
			// 			title: "Sales",
			// 			dataIndex: "salesAverage",
			// 			key: "salesAverage",
			// 			render: (value) => {
			// 				return (
			// 					<Statistic
			// 						title=""
			// 						value={value}
			// 						precision={2}
			// 						valueStyle={{ fontSize: 14 }}
			// 						prefix={"$"}
			// 					/>
			// 				);
			// 			},
			// 		},
			// 		{
			// 			title: "Gross",
			// 			dataIndex: "grossAverage",
			// 			key: "grossAverage",
			// 			render: (value) => {
			// 				return (
			// 					<Statistic
			// 						title=""
			// 						value={value}
			// 						precision={2}
			// 						valueStyle={{ fontSize: 14 }}
			// 						prefix={"$"}
			// 					/>
			// 				);
			// 			},
			// 		},
			// 	],
			// },
			// {
			// 	title: "Utility",
			// 	dataIndex: "utility",
			// 	key: "utility",
			// 	render: (value) => {
			// 		return (
			// 			<Statistic
			// 				title=""
			// 				value={value}
			// 				precision={2}
			// 				valueStyle={{ fontSize: 14 }}
			// 				prefix={"$"}
			// 			/>
			// 		);
			// 	},
			// },
		];

		const summary = (pageData) => {
			let totalYardsTotal = 0;
			let totalUnitPriceTotal = 0;
			let missionCYTotal = 0;
			let sanbenitoCYTotal = 0;
			let brownsvilleCYTotal = 0;
			let missionCommissionTotal = 0;
			let sanbenitoCommissionTotal = 0;
			let brownsvilleCommissionTotal = 0;
			let missionPayoutTotal = 0;
			let sanbenitoPayoutTotal = 0;
			let brownsvillePayoutTotal = 0;
			let missionCogsTotal = 0;
			let sanbenitoCogsTotal = 0;
			let brownsvilleCogsTotal = 0;
			let missionSalesTotal = 0;
			let sanbenitoSalesTotal = 0;
			let brownsvilleSalesTotal = 0;
			let missionGrossTotal = 0;
			let sanbenitoGrossTotal = 0;
			let brownsvilleGrossTotal = 0;

			pageData.forEach(
				({
					totalYards,
					totalUnitPrice,
					missionCY,
					sanbenitoCY,
					brownsvilleCY,
					missionCogs,
					sanbenitoCogs,
					brownsvilleCogs,
					missionSales,
					sanbenitoSales,
					brownsvilleSales,
					missionGross,
					sanbenitoGross,
					brownsvilleGross,
					missionCommission,
					sanbenitoCommission,
					brownsvilleCommission,
					missionPayout,
					sanbenitoPayout,
					brownsvillePayout,
				}) => {
					totalYardsTotal += totalYards;
					totalUnitPriceTotal += totalUnitPrice;
					missionCYTotal += missionCY || 0;
					sanbenitoCYTotal += sanbenitoCY || 0;
					brownsvilleCYTotal += brownsvilleCY || 0;
					missionCogsTotal += missionCogs || 0;
					sanbenitoCogsTotal += sanbenitoCogs || 0;
					brownsvilleCogsTotal += brownsvilleCogs || 0;
					missionSalesTotal += missionSales || 0;
					sanbenitoSalesTotal += sanbenitoSales || 0;
					brownsvilleSalesTotal += brownsvilleSales || 0;
					missionGrossTotal += missionGross || 0;
					sanbenitoGrossTotal += sanbenitoGross || 0;
					brownsvilleGrossTotal += brownsvilleGross || 0;
					missionCommissionTotal += missionCommission || 0;
					sanbenitoCommissionTotal += sanbenitoCommission || 0;
					brownsvilleCommissionTotal += brownsvilleCommission || 0;
					missionPayoutTotal += missionPayout || 0;
					sanbenitoPayoutTotal += sanbenitoPayout || 0;
					brownsvillePayoutTotal += brownsvillePayout || 0;
				}
			);

			return (
				<>
					<Table.Summary.Row>
						<Table.Summary.Cell colSpan={1} />
						<Table.Summary.Cell>
							<Text style={{ fontSize: 14 }} strong>
								{"Total"}
							</Text>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={totalYardsTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={totalUnitPriceTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell colSpan={1} />
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={missionCYTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={sanbenitoCYTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={brownsvilleCYTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={missionCommissionTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={sanbenitoCommissionTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={brownsvilleCommissionTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={missionPayoutTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={sanbenitoPayoutTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={brownsvillePayoutTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell colSpan={1} />
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={missionCogsTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={sanbenitoCogsTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={brownsvilleCogsTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={missionSalesTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={sanbenitoSalesTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={brownsvilleSalesTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={missionGrossTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={sanbenitoGrossTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={brownsvilleGrossTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
					</Table.Summary.Row>
				</>
			);
		};

		const jobs = row.jobs.map((item, index) => {
			let plant = {};
			let totalCogs = 0;
			switch (item.plant.name) {
				case "Mission":
					plant.missionCY = item.loadYD3;
					plant.missionCommission =
						item.psiId.plants?.find((i) => i.plant === item.plant._id)
							?.commission ?? 0;
					plant.missionPayout = plant.missionCY * plant.missionCommission;
					totalCogs = getAggregateCogsCost(item.aggregate);
					plant.missionCogs = totalCogs;
					plant.missionSales = item.unitPrice;
					plant.missionGross = plant.missionSales - plant.missionCogs;
					// plant.cogsAverage = plant.missionCogs;
					// plant.salesAverage = plant.missionSales;
					// plant.grossAverage = plant.missionGross;
					// plant.utility = plant.missionGross * plant.missionCY;
					break;
				case "San Benito":
					plant.sanbenitoCY = item.loadYD3;
					plant.sanbenitoCommission =
						item.psiId.plants?.find((i) => i.plant === item.plant._id)
							?.commission ?? 0;
					plant.sanbenitoPayout = plant.sanbenitoCY * plant.sanbenitoCommission;
					totalCogs = getAggregateCogsCost(item.aggregate);
					plant.sanbenitoCogs = totalCogs;
					plant.sanbenitoSales = item.unitPrice;
					plant.sanbenitoGross = plant.sanbenitoSales - plant.sanbenitoCogs;
					// plant.cogsAverage = plant.sanbenitoCogs;
					// plant.salesAverage = plant.sanbenitoSales;
					// plant.grossAverage = plant.sanbenitoGross;
					// plant.utility = plant.sanbenitoGross * plant.sanbenitoCY;
					break;
				case "Brownsville":
					plant.brownsvilleCY = item.loadYD3;
					plant.brownsvilleCommission =
						item.psiId.plants?.find((i) => i.plant === item.plant._id)
							?.commission ?? 0;
					plant.brownsvillePayout =
						plant.brownsvilleCY * plant.brownsvilleCommission;
					totalCogs = getAggregateCogsCost(item.aggregate);
					plant.brownsvilleCogs = totalCogs;
					plant.brownsvilleSales = item.unitPrice;
					plant.brownsvilleGross =
						plant.brownsvilleSales - plant.brownsvilleCogs;
					// plant.cogsAverage = plant.brownsvilleCogs;
					// plant.salesAverage = plant.brownsvilleSales;
					// plant.grossAverage = plant.brownsvilleGross;
					// plant.utility = plant.brownsvilleGross * plant.brownsvilleCY;
					break;

				default:
					break;
			}

			return {
				...item,
				key: index,
				seller: item.seller.name,
				psi: item.psiId.psi,
				totalYards: item.loadYD3,
				totalUnitPrice: item.loadYD3 * item.unitPrice,
				totalAverage: (item.loadYD3 * item.unitPrice) / item.loadYD3,
				client: item.customer.name,
				...plant,
			};
		});

		return (
			<Table
				columns={columns}
				dataSource={jobs}
				pagination={false}
				summary={summary}
			/>
		);
	};

	useEffect(() => {
		getSellerList();
	}, []);

	useEffect(() => {
		getLogisticsList();
	}, [startDate, endDate, seller]);

	const getLogisticsList = async () => {
		setLoading(true);
		setListCSV([]);

		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api +
			`/job/get/salesbyseller/${seller}?startDate=${start}&endDate=${end}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				const groupedPsi = data.payload
					.filter((i) => i.psiId !== null && i.psiId !== undefined)
					.reduce((acc, item) => {
						if (!acc[`${item.psiId._id}_${item.psiId.psi}`]) {
							acc[`${item.psiId._id}_${item.psiId.psi}`] = [];
						}
						acc[`${item.psiId._id}_${item.psiId.psi}`].push(item);
						return acc;
					}, {});

				const newRows = Object.entries(groupedPsi).map(([key, values]) => {
					const firstRow = values[0];
					const [psiId, psiName] = key.split("_");

					let obj = {
						key: psiId,
						index: psiId,
						customer: "All Customers",
						seller: seller === "All" ? "All Sellers" : firstRow.seller.name,
						psi: psiName,
						jobs: values,
						totalYards: values.reduce((accum, r) => accum + r.loadYD3, 0),
						totalUnitPrice: values.reduce(
							(accum, r) => accum + r.loadYD3 * r.unitPrice,
							0
						),
					};
					return obj;
				});

				const listRows2 = [];

				const newList = newRows.map((itemRow) => {
					let plant = {
						missionCY: 0,
						missionCommission: 0,
						missionPayout: 0,
						missionCogs: 0,
						missionSales: 0,
						missionGross: 0,
						sanbenitoCY: 0,
						sanbenitoCommission: 0,
						sanbenitoPayout: 0,
						sanbenitoCogs: 0,
						sanbenitoSales: 0,
						sanbenitoGross: 0,
						brownsvilleCY: 0,
						brownsvilleCommission: 0,
						brownsvillePayout: 0,
						brownsvilleCogs: 0,
						brownsvilleSales: 0,
						brownsvilleGross: 0,
						// cogsAverage: 0,
						// salesAverage: 0,
						// grossAverage: 0,
						// utility: 0,
						totalAverage: 0,
					};
					itemRow.jobs.map((item, index) => {
						const loadYD3 = item.loadYD3;
						const commission =
							item.psiId.plants?.find((i) => i.plant === item.plant._id)
								?.commission ?? 0;
						const cogs = getAggregateCogsCost(item.aggregate);
						const gross = item.unitPrice - cogs;
						plant.totalAverage +=
							(item.loadYD3 * item.unitPrice) / item.loadYD3;
						switch (item.plant.name) {
							case "Mission":
								plant.missionCY += loadYD3;
								plant.missionCommission += commission;
								plant.missionPayout += loadYD3 * commission;
								plant.missionCogs += cogs;
								plant.missionSales += item.unitPrice;
								plant.missionGross += gross;
								// plant.cogsAverage += cogs;
								// plant.salesAverage += item.unitPrice;
								// plant.grossAverage += gross;
								// plant.utility += gross * loadYD3;
								break;
							case "San Benito":
								plant.sanbenitoCY += loadYD3;
								plant.sanbenitoCommission += commission;
								plant.sanbenitoPayout += loadYD3 * commission;
								plant.sanbenitoCogs += cogs;
								plant.sanbenitoSales += item.unitPrice;
								plant.sanbenitoGross += gross;
								// plant.cogsAverage += cogs;
								// plant.salesAverage += item.unitPrice;
								// plant.grossAverage += gross;
								// plant.utility += gross * loadYD3;
								break;
							case "Brownsville":
								plant.brownsvilleCY += loadYD3;
								plant.brownsvilleCommission += commission;
								plant.brownsvillePayout += loadYD3 * commission;
								plant.brownsvilleCogs += cogs;
								plant.brownsvilleSales += item.unitPrice;
								plant.brownsvilleGross += gross;
								// plant.cogsAverage += cogs;
								// plant.salesAverage += item.unitPrice;
								// plant.grossAverage += gross;
								// plant.utility += gross * loadYD3;
								break;

							default:
								break;
						}

						let plant2 = {};
						let totalCogs = 0;
						switch (item.plant.name) {
							case "Mission":
								plant2.missionCY = item.loadYD3;
								plant2.missionCommission =
									item.psiId.plants?.find((i) => i.plant === item.plant._id)
										?.commission ?? 0;
								plant2.missionPayout =
									plant2.missionCY * plant2.missionCommission;
								totalCogs = getAggregateCogsCost(item.aggregate);
								plant2.missionCogs = totalCogs;
								plant2.missionSales = item.unitPrice;
								plant2.missionGross = plant2.missionSales - plant2.missionCogs;
								// plant2.cogsAverage = plant2.missionCogs;
								// plant2.salesAverage = plant2.missionSales;
								// plant2.grossAverage = plant2.missionGross;
								// plant2.utility = plant2.missionGross * plant2.missionCY;
								break;
							case "San Benito":
								plant2.sanbenitoCY = item.loadYD3;
								plant2.sanbenitoCommission =
									item.psiId.plants?.find((i) => i.plant === item.plant._id)
										?.commission ?? 0;
								plant2.sanbenitoPayout =
									plant2.sanbenitoCY * plant2.sanbenitoCommission;
								totalCogs = getAggregateCogsCost(item.aggregate);
								plant2.sanbenitoCogs = totalCogs;
								plant2.sanbenitoSales = item.unitPrice;
								plant2.sanbenitoGross =
									plant2.sanbenitoSales - plant2.sanbenitoCogs;
								// plant2.cogsAverage = plant2.sanbenitoCogs;
								// plant2.salesAverage = plant2.sanbenitoSales;
								// plant2.grossAverage = plant2.sanbenitoGross;
								// plant2.utility = plant2.sanbenitoGross * plant2.sanbenitoCY;
								break;
							case "Brownsville":
								plant2.brownsvilleCY = item.loadYD3;
								plant2.brownsvilleCommission =
									item.psiId.plants?.find((i) => i.plant === item.plant._id)
										?.commission ?? 0;
								plant2.brownsvillePayout =
									plant2.brownsvilleCY * plant2.brownsvilleCommission;
								totalCogs = getAggregateCogsCost(item.aggregate);
								plant2.brownsvilleCogs = totalCogs;
								plant2.brownsvilleSales = item.unitPrice;
								plant2.brownsvilleGross =
									plant2.brownsvilleSales - plant2.brownsvilleCogs;
								// plant2.cogsAverage = plant2.brownsvilleCogs;
								// plant2.salesAverage = plant2.brownsvilleSales;
								// plant2.grossAverage = plant2.brownsvilleGross;
								// plant2.utility = plant2.brownsvilleGross * plant2.brownsvilleCY;
								break;

							default:
								break;
						}

						listRows2.push({
							...item,
							key: item.psiId._id,
							seller: item.seller.name,
							psi: item.psiId.psi,
							totalYards: item.loadYD3,
							totalUnitPrice: item.loadYD3 * item.unitPrice,
							totalAverage: (item.loadYD3 * item.unitPrice) / item.loadYD3,
							client: item.customer.name,
							...plant2,
						});
					});

					// let existsPlantsCogs = 0;
					// let existsPlantsSales = 0;
					// let existsPlantsGross = 0;
					// if (plant.missionCogs !== 0) {
					// 	existsPlantsCogs += 1;
					// }
					// if (plant.sanbenitoCogs !== 0) {
					// 	existsPlantsCogs += 1;
					// }
					// if (plant.brownsvilleCogs !== 0) {
					// 	existsPlantsCogs += 1;
					// }
					// if (plant.missionSales !== 0) {
					// 	existsPlantsSales += 1;
					// }
					// if (plant.sanbenitoSales !== 0) {
					// 	existsPlantsSales += 1;
					// }
					// if (plant.brownsvilleSales !== 0) {
					// 	existsPlantsSales += 1;
					// }
					// if (plant.missionGross !== 0) {
					// 	existsPlantsGross += 1;
					// }
					// if (plant.sanbenitoGross !== 0) {
					// 	existsPlantsGross += 1;
					// }
					// if (plant.brownsvilleGross !== 0) {
					// 	existsPlantsGross += 1;
					// }

					const jobsMission = itemRow.jobs.filter(
						(i) => i.plant.name === "Mission"
					).length;
					const jobsSanBenito = itemRow.jobs.filter(
						(i) => i.plant.name === "San Benito"
					).length;
					const jobsBrownsville = itemRow.jobs.filter(
						(i) => i.plant.name === "Brownsville"
					).length;

					return {
						...itemRow,
						...plant,
						// cogsAverage:
						// 	existsPlantsCogs !== 0 ? plant.cogsAverage / existsPlantsCogs : 0,
						// salesAverage:
						// 	existsPlantsSales !== 0
						// 		? plant.salesAverage / existsPlantsSales
						// 		: 0,
						// grossAverage:
						// 	existsPlantsGross !== 0
						// 		? plant.grossAverage / existsPlantsGross
						// 		: 0,
						totalAverage: plant.totalAverage / itemRow.jobs.length,
						missionCogs: plant.missionCogs / jobsMission || 0,
						missionSales: plant.missionSales / jobsMission || 0,
						missionGross: plant.missionGross / jobsMission || 0,
						missionCommission: plant.missionCommission / jobsMission || 0,
						sanbenitoCogs: plant.sanbenitoCogs / jobsSanBenito || 0,
						sanbenitoSales: plant.sanbenitoSales / jobsSanBenito || 0,
						sanbenitoGross: plant.sanbenitoGross / jobsSanBenito || 0,
						sanbenitoCommission: plant.sanbenitoCommission / jobsSanBenito || 0,
						brownsvilleCogs: plant.brownsvilleCogs / jobsBrownsville || 0,
						brownsvilleSales: plant.brownsvilleSales / jobsBrownsville || 0,
						brownsvilleGross: plant.brownsvilleGross / jobsBrownsville || 0,
						brownsvilleCommission:
							plant.brownsvilleCommission / jobsBrownsville || 0,
						client: "All Clients",
					};
				});

				setList(newList);
				setListCSV(listRows2);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", "Error while trying to get jobs");
			console.error(err.message);
			return null;
		}
	};

	const getSellerList = async () => {
		const url = api + "/user/list/57Concrete/Seller";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [
					{
						value: "All",
						label: "All",
					},
				];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						value: item._id,
						label: item.name,
					});
				});
				setSellerOptions(list);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Table
					columns={columns}
					dataSource={list}
					expandable={{
						expandedRowRender,
					}}
					pagination={{
						position: ["bottomRight"],
						pageSizeOptions: [50, 100],
						defaultPageSize: 50,
						showSizeChanger: true,
					}}
					scroll={{
						x: "max-content",
					}}
					style={{
						minWidth: "100%",
					}}
					onRow={(record) => ({
						style: {
							background: "#7686bbff",
						},
					})}
					summary={summaryParent}
				/>
			</Flex>
		);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const onChangeSellerPicker = (value) => {
		setSeller(value);
	};

	const RenderDates = () => {
		return (
			<CustomSearch
				loading={loading}
				startDate={startDate}
				endDate={endDate}
				dateFormat={"MM/DD/YYYY"}
				onRangeChange={onRangeChange}
				onChangePicker={onChangeSellerPicker}
				pickerValue={seller}
				pickerWidth={"250px"}
				labelPicker={"Seller"}
				disabledPicker={loading}
				optionsPicker={sellerOptions}
			/>
		);
	};

	function getFlattenedHeaders(columns, parent = "") {
		return columns.flatMap((col) => {
			const title = col.title;
			// const title = parent ? `${parent} - ${col.title}` : col.title;
			if (col.children) {
				return getFlattenedHeaders(col.children, title);
			}
			return title;
		});
	}

	function getFlattenedKeys(columns, parent = "") {
		return columns.flatMap((col) => {
			if (col.children) {
				return getFlattenedKeys(col.children, parent); // skip grouping name
			}
			return col.dataIndex || col.key || ""; // prefer dataIndex, fallback to key
		});
	}

	const handleExportXlsx = () => {
		// Step 1: Get headers
		let data = [];
		const headers = getFlattenedHeaders(columns);
		const keys = getFlattenedKeys(columns);

		data.push(["SELLER REPORT DETAIL"]);
		data.push(["SELLER REPORT SUMMARY"]);
		data.push([]);
		data.push(["Lower", "Upper"]);
		const start = `${
			startDate.month() + 1
		}/${startDate.date()}/${startDate.year()}`;
		const end = `${endDate.month() + 1}/${endDate.date()}/${endDate.year()}`;
		data.push([start, end]);
		data.push([]);
		data.push(["Seller", seller === "All" ? "All Sellers" : list[0].seller]);

		const topHeader = [
			"",
			"",
			"",
			"",
			"",
			"CY",
			"CY",
			"CY",
			"",
			"Commission by plant",
			"",
			"",
			"Seller Payout",
			"",
			"",
			"COGS",
			"COGS",
			"COGS",
			"SALES",
			"SALES",
			"SALES",
			"GROSS",
			"GROSS",
			"GROSS",
			// "COGS",
			// "SALES",
			// "GROSS",
		];
		data.push(topHeader);
		data.push(headers);

		list.map((itemList) => {
			const childrenList = listCSV.filter((l) => l.key === itemList.key);
			childrenList.map((children, index) => {
				let newRow = [];
				// if (index === 0) {
				// 	keys.forEach((key) => {
				// 		newRow.push(children[key] ?? ""); // or undefined/null fallback
				// 	});
				// } else {
				// 	newRow.push("");
				// 	keys.slice(1).forEach((key) => {
				// 		newRow.push(children[key] ?? ""); // or undefined/null fallback
				// 	});
				// }
				keys.forEach((key) => {
					newRow.push(children[key] ?? ""); // or undefined/null fallback
				});
				data.push(newRow);
			});
			let totalRow = ["", ""];
			keys.slice(2).forEach((key) => {
				totalRow.push(itemList[key] ?? ""); // or undefined/null fallback
			});
			data.push(totalRow);
			data.push([]);
		});

		// Step 2: Create a worksheet with one row
		const ws = XLSX.utils.aoa_to_sheet(data);

		// Step 3: Create a workbook
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(
			wb,
			ws,
			seller === "All" ? "All Sellers" : list[0].seller
		);

		// Step 4: Export file
		XLSX.writeFile(wb, `57 Sales Report By Seller.xlsx`);
	};

	const RenderDownloadReport = () => {
		return (
			<div>
				<Row gutter={16}>
					<Col span={24}>
						<Button
							type="primary"
							style={{ width: "100%" }}
							onClick={handleExportXlsx}
							loading={loading}
							disabled={list.length === 0}
						>
							Download Report
						</Button>
					</Col>
				</Row>
			</div>
		);
	};

	return (
		<Layout
			title="Rate Per Seller Report"
			description="Seller Report"
			type="large"
		>
			<Flex vertical gap={"large"}>
				<RenderDates />
				<RenderDownloadReport />
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
			{contextHolder}
		</Layout>
	);
};

export default SalesBySellerSummary;
